import { RouteRecordRaw } from 'vue-router'
import { RolesMap } from '@/models/user'
import ProjectModule from './ProjectModule.vue'
import ListProjects from './views/ListProjects.vue'
import ShowProject from './views/ShowProject.vue'
import CreateProject from './views/CreateProject.vue'
import EditProject from './views/EditProject.vue'
import ListExpenses from './views/ListExpenses.vue'
import Scheduling from './views/ProjectScheduling.vue'
import ListInvoices from './views/ListInvoices.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/projects',
    component: ProjectModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE, RolesMap.CUSTOMER_ROLE] },
    children: [
      {
        path: '',
        name: 'ListProjects',
        component: ListProjects,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateProject',
        component: CreateProject,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE, RolesMap.CUSTOMER_ROLE] }
      },
      {
        path: 'c/:customerId/:projectId',
        name: 'ShowProject',
        component: ShowProject,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE, RolesMap.CUSTOMER_ROLE] }
      },
      {
        path: 'c/:customerId/',
        name: 'ListCustomerProjects',
        component: ListProjects,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE, RolesMap.CUSTOMER_ROLE] }
      },
      {
        path: 'edit/c/:customerId/:projectId',
        name: 'EditProject',
        component: EditProject,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'expenses/c/:customerId/:projectId',
        name: 'ListProjectExpenses',
        component: ListExpenses,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'scheduling/c/:customerId/:projectId',
        name: 'Scheduling',
        component: Scheduling,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'income/c/:customerId/:projectId',
        name: 'ListProjectIncome',
        component: ListInvoices,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
